var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoChip = function SvgVideoChip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 20 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5C0 2.12 1.12 1 2.5 1H11.5C12.88 1 14 2.12 14 3.5V10.5C14 11.88 12.88 13 11.5 13H2.5C1.12 13 0 11.88 0 10.5V3.5ZM15.5 5.2L19.2 2.6C19.6 2.3 20 2.6 20 3V11C20 11.4 19.6 11.7 19.2 11.4L15.5 8.8V5.2Z",
    fill: "#ffffff"
  })));
};
export default SvgVideoChip;